// ManualDepositHelp.tsx — i18n-ready (uses t())

import {
  Box,
  Card,
  CardContent,
  Chip,
  Divider,
  IconButton,
  Link as MLink,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from '@mui/material';
import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales';

const MP_LINK = 'https://link.mercadopago.cl/telyza';

const BANK = {
  holder: 'Telyza',
  rut: '26.012.939-2',
  type: 'Cuenta Corriente',
  number: '000095968155',
  bank: 'Banco Santander',
  email: 'telyzagame@gmail.com',
};

const MERCADO = {
  holder: 'Telyza',
  rut: '260129392',
  platform: 'Mercado Pago',
  accountType: 'Cuenta Vista',
  number: '1044066838',
  email: 'telyzagame@gmail.com',
};

function copy(text: string) {
  navigator.clipboard?.writeText(text);
}

export default function ManualDepositHelp() {
  const { t } = useTranslate();

  return (
    <Card variant="outlined" sx={{ bgcolor: 'background.paper', borderRadius: 2 }}>
      <CardContent sx={{ py: 2 }}>
        <Box sx={{ display: 'grid', gap: 2 }}>
          {/* Option A: MercadoPago link */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Chip label="1" size="small" />
              <MLink href={MP_LINK} target="_blank" rel="noopener" underline="hover">
                {t('deposit_manual_help.mercado_link_label')}
              </MLink>
            </Box>
            <Box>
              <Tooltip title={t('deposit_manual_help.open')}>
                <IconButton href={MP_LINK} target="_blank" rel="noopener">
                  <Iconify icon="mdi:open-in-new" width={18} />
                </IconButton>
              </Tooltip>
              <Tooltip title={t('deposit_manual_help.copy')}>
                <IconButton onClick={() => copy(MP_LINK)}>
                  <Iconify icon="mdi:content-copy" width={18} />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>

          <Divider />

          {/* Option B: Mercado account details */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip label="2" size="small" />
            <Typography variant="subtitle2">{t('deposit_manual_help.mercado_account')}</Typography>
          </Box>
          <List dense disablePadding>
            {[
              { k: 'holder', label: t('deposit_manual_help.holder'), value: MERCADO.holder },
              { k: 'rut', label: t('deposit_manual_help.rut'), value: MERCADO.rut },
              { k: 'platform', label: t('deposit_manual_help.platform'), value: MERCADO.platform },
              {
                k: 'accountType',
                label: t('deposit_manual_help.account_type'),
                value: MERCADO.accountType,
              },
              {
                k: 'number',
                label: t('deposit_manual_help.account_number'),
                value: MERCADO.number,
              },
              { k: 'email', label: t('deposit_manual_help.email'), value: MERCADO.email },
            ].map((item) => (
              <ListItem
                key={`mercado-${item.k}`}
                secondaryAction={
                  <Tooltip title={t('deposit_manual_help.copy')}>
                    <IconButton edge="end" onClick={() => copy(item.value)}>
                      <Iconify icon="mdi:content-copy" width={18} />
                    </IconButton>
                  </Tooltip>
                }
              >
                <ListItemText primary={item.label} secondary={item.value} />
              </ListItem>
            ))}
          </List>

          <Divider />

          {/* Option C: Bank transfer */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Chip label="3" size="small" />
            <Typography variant="subtitle2">{t('deposit_manual_help.bank_transfer')}</Typography>
          </Box>
          <List dense disablePadding>
            {[
              { k: 'holder', label: t('deposit_manual_help.holder'), value: BANK.holder },
              { k: 'rut', label: t('deposit_manual_help.rut'), value: BANK.rut },
              { k: 'account_type', label: t('deposit_manual_help.account_type'), value: BANK.type },
              {
                k: 'account_number',
                label: t('deposit_manual_help.account_number'),
                value: BANK.number,
              },
              { k: 'bank', label: t('deposit_manual_help.bank'), value: BANK.bank },
              { k: 'email', label: t('deposit_manual_help.email'), value: BANK.email },
            ].map((item) => (
              <ListItem
                key={`bank-${item.k}`}
                secondaryAction={
                  <Tooltip title={t('deposit_manual_help.copy')}>
                    <IconButton edge="end" onClick={() => copy(item.value)}>
                      <Iconify icon="mdi:content-copy" width={18} />
                    </IconButton>
                  </Tooltip>
                }
              >
                <ListItemText primary={item.label} secondary={item.value} />
              </ListItem>
            ))}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
}
